export default __webpack_public_path__ + "static/media/unicons.31bc3765.woff";